<template>
  <line-up :team-id="teamId" :actions="actions" :data="data" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LineUp from './components/line-up'
export default {
  name: 'TabLineUp',
  components: { LineUp },
  props: {
    teamId: {
      type: String,
      required: true,
      default: '',
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapState({
      lineUp: (state) => state.teams.lineUp,
    }),

    actions() {
      return {
        fetchLineUpList: this.fetchLineUpList,
        fetchLineUp: this.fetchLineUp,
        addLineUp: this.addLineUp,
        updateLineUp: this.updateLineUp,
        deleteLineUp: this.deleteLineUp,
        updateFormation: this.updateTeam,
      }
    },
    data() {
      return { ...this.lineUp }
    },
  },
  methods: {
    ...mapActions({
      fetchLineUpList: 'teams/fetchLineUpList',
      fetchLineUp: 'teams/fetchLineUp',
      addLineUp: 'teams/addLineUp',
      updateLineUp: 'teams/updateLineUp',
      deleteLineUp: 'teams/deleteLineUp',
      updateTeam: 'teams/update',
    }),
  },
}
</script>
